import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import style from "./style.module.css";
import general from "../../css/General.module.css";
import { WEBSITE_NAME } from '../../modals/Constants';
import { getStorage } from '../../modals/Storage';
import Button from '../../UI/Button/ui';

function View({ screen }) {
    const [menuSlider, setMenuSlider] = useState(false);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const stored = getStorage("categories");
        if (stored) {
            setCategories(JSON.parse(stored));
        }
    }, []);

    return (
        <div className={style.parentView}>
            <section>
                <h3>{WEBSITE_NAME}</h3>
                <p>Your Favorite Designs, One Click Away.</p>

                <Button text="Need Help"
                    icon={"support_agent"}
                    rounded={true}
                    hoverEffect={true}
                    spaceTop={15}
                    action={{ onClick: () => window.open(getStorage("app_whatsapp_support_url"), "_blank") }} />
            </section>

            <section>
                <p className={style.hint}>About us</p>
                <Link to={"pages/about-us"} target='_blank'>
                    About us
                </Link>
                <Link to={"pages/contact-us"} target='_blank'>
                    Contact us
                </Link>
            </section>

            {categories.length > 0 ?
                <section>
                    <p className={style.hint}>Categories</p>

                    {categories.map((data, index) => (
                        <Link key={`category_${index}`}
                            to={{
                                pathname: "/search",
                                search: `?q=${encodeURIComponent(data["item_id"])}&d=${encodeURIComponent(data["item_name"])}&linked=true`
                            }}>
                            {data.item_name}
                        </Link>
                    ))}
                </section>
                : null}

            <section>
                <p className={style.hint}>Help</p>
                <Link to={"/myorders"}>
                    Track Order
                </Link>
                <Link to={"/pages/terms-and-condition"} target='_blank'>
                    Terms & Condition
                </Link>

                <Link to={"pages/return-policy"} target='_blank'>
                    Return Policy
                </Link>

                <Link to={"pages/privacy-policy"} target='_blank'>
                    Privacy Policy
                </Link>

                <Link to={"pages/faq"} target='_blank'>
                    FAQ
                </Link>
            </section>
        </div>
    );
}

export default View;